import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationUtilisateur } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'

const { creation, edit, deletion } = notificationUtilisateur

// Redux Toolkit slice
const utilisateursSlice = createSlice({
    name: 'utilisateurs',
    initialState: {
        data: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {
        resetUtilisateurs: (state) => {
            if (state.detailsUtilisateur == null) {
                state.detailsUtilisateur = ''
            } else {
                state.detailsUtilisateur = null
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDetailsUtilisateurs.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchDetailsUtilisateurs.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.detailsUtilisateur = action.payload
            })
            .addCase(fetchDetailsUtilisateurs.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(fetchUtilisateurs.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchUtilisateurs.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchUtilisateurs.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(createUtilisateur.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(createUtilisateur.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(createUtilisateur.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })
            .addCase(deleteUtilisateur.pending, (state) => {
                state.isLoading = true
                state.isDeleted = null
            })
            .addCase(deleteUtilisateur.fulfilled, (state) => {
                state.isLoading = false
                state.isDeleted = true
            })
            .addCase(deleteUtilisateur.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.isDeleted = false
            })
    },
})

// Async thunk action to fetch data from the API
export const fetchUtilisateurs = createAsyncThunk(
    'utilisateurs/fetch',
    async (payload) => {
        const page = payload?.page || 1
        const limit = payload?.limit || LIMIT
        const search = payload?.search || ''
        const statut_f = payload?.statut_f || ''
        let date_d_f = payload?.date?.[0] || ''
        let date_f_f = payload?.date?.[1] || ''
        if (dayjs(date_d_f).isValid() && dayjs(date_f_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
        } else if (dayjs(date_d_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = date_d_f;
        } else if (dayjs(date_f_f).isValid()) {
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
            date_d_f = date_f_f;
        }
        try {
            const response = await BaseService.get(
                `/XML/compte/utilisateurs?page=${page}&limit=${limit}&text=${search}&statut_f=${statut_f}&date_d_f=${date_d_f}&date_f_f=${date_f_f}`
            )

            return response.data
        } catch (error) {
            throw new Error('Failed to fetch utilisateurs')
        }
    }
)
// Async thunk action to fetch details from the API
export const fetchDetailsUtilisateurs = createAsyncThunk(
    'Utilisateurs/fetchDetails',
    async (id) => {

        const data = { 'ido': id.id }
        try {
            const Utilisateur = await BaseService.post(
                `/XML/compte/get_operateur`, data
            )


            return { 'utilisateur': Utilisateur.data }
        } catch (error) {
            throw new Error('Failed to fetch Utilisateurs')
        }
    }
)

export const createUtilisateur = createAsyncThunk(
    'utilisateurs/post',
    async (payload) => {
        const { data, formik, navigate, setClientAdded } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/XML/compte.send/add', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                setClientAdded(true)
            }
        } catch (err) {
            console.log({ err })
            setSubmitting(false)
            popNotification(creation?.error)
        }
    }
)



export const resetPassword = createAsyncThunk(
    'password/post',
    async (payload) => {
        const { id, setUtilisateurAdded } = payload
        const data = { 'id': id }
        try {
            const response = await BaseService.post('/XML/compte.send/resetPassword', data)
            if (response.status === 200) {


                popNotification(creation?.success)
                setUtilisateurAdded(true)
            }
        } catch (err) {
            console.log({ err })
            

            
            popNotification(creation?.error)
        }
    }
)

export const editUtilisateur = createAsyncThunk('utilisateurs/edit',
    async (payload) => {
        const { data, formik, navigate, setClientAdded } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/XML/compte.send/edit', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                setClientAdded(true)
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)

export const deleteUtilisateur = createAsyncThunk(
    'utilisateur/delete',
    async (payload) => {
        const { id, closeDialog } = payload
        if (!id) return
        try {
            const response = await BaseService.delete(`/utilisateurs/${id}`)
            if (response.status === 200 || response.status === 201) {
                popNotification(deletion?.success)
                closeDialog()
                return true
            }
        } catch (err) {
            console.log({ err })
            popNotification(deletion?.error)
            return
        }
    }
)


export const selectData = (state) => state.utilisateurs.data
export const selectIsLoading = (state) => state.utilisateurs.isLoading
export const selectError = (state) => state.utilisateurs.error
export const selectIsDeleted = (state) => state.utilisateurs.isDeleted
export const selectCurrentPage = (state) => state.utilisateurs.currentPage
export const resetUtilisateurs = utilisateursSlice.actions.resetUtilisateurs
export default utilisateursSlice.reducer
